import { Container } from '@chakra-ui/react'
import { Routes, Route } from 'react-router-dom'
import SettingsLayout from '../../Layout/Settings/SettingsLayout'
import SystemInfo from './SystemInfo/SystemInfo'
import Locales from './Locales/Locales'
import EditLocale from './Locales/EditLocale'
import CreateLocale from './Locales/CreateLocale'
import ApiKeys from './ApiKeys/ApiKeys'
import EditApiKey from './ApiKeys/EditApiKey'
import CreateApiKey from './ApiKeys/CreateApiKey'

const Settings = () => {
  return (
    <Container maxW="container.2xl">
      <SettingsLayout>
        <Routes>
          <Route path="system" element={<SystemInfo />} />
          <Route path="locales" element={<Locales />} />
          <Route path="locales/edit/:id" element={<EditLocale />} />
          <Route path="locales/create" element={<CreateLocale />} />
          <Route path="api-keys" element={<ApiKeys />} />
          <Route path="api-keys/edit/:id" element={<EditApiKey />} />
          <Route path="api-keys/create" element={<CreateApiKey />} />
          <Route path="*" element={<SystemInfo />} />
        </Routes>
      </SettingsLayout>
    </Container>
  )
}

export default Settings